import { Sun, Battery, Zap, Package, Cable, ChevronRight, Star, Users, ShoppingCart, Search } from 'lucide-react';

import { useState } from 'react';
import { Link } from 'react-router-dom';
import logo from '../assets/klogo2.png'
export default function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isServicesDropdownOpen, setIsServicesDropdownOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const [searchFocused, setSearchFocused] = useState(false);
  const [cartCount, setCartCount] = useState(0);
  
  return (
    <header className="bg-white shadow-md sticky top-0 z-50">
    <nav className="max-w-7xl mx-auto px-4">
      <div className="flex justify-between items-center ">
        
      <div className="flex items-center space-x-2">
      <img 
          src={logo} 
          alt="Krikosh Logo" 
          className="h-12 my-5 w-auto" // Adjust the size as needed
        />
    </div>

        {/* Desktop Menu */}
        <div className="hidden md:flex space-x-8 relative ">
          <Link to="/" className={`text-gray-600 font-medium hover:text-primary-dark py-5`}>Home</Link>

          {/* Services Dropdown */}
          <div
            className="relative py-5"
            onMouseEnter={() => setIsServicesDropdownOpen(true)}
            onMouseLeave={() => setIsServicesDropdownOpen(false)}
          >
            <Link
              to="/about"
              className={`text-gray-600 font-medium hover:text-primary-dark relative`}
            >
              About
            </Link>
            
          </div>

          <Link to="/contact" className={`text-gray-600 font-medium hover:text-primary-dark py-5`}>Contact Us</Link>
        </div>
        
        {/* Mobile Menu Button */}
        <button 
          className="md:hidden p-2"
          onClick={() => setIsMenuOpen(!isMenuOpen)}
        >
          <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
          </svg>
        </button>
      </div>
      
      {/* Mobile Menu */}
      {isMenuOpen && (
        <div className="md:hidden absolute bg-white w-full left-0 px-4 pb-4 shadow-md">
          <Link to="/" className={`block py-2 text-gray-600 hover:text-primary-dark`}>Home</Link>
          <div className="relative">
            <Link to="/about" className={`block py-2 text-gray-600 hover:text-primary-dark`}>
              About
            </Link>
            
          </div>
          <Link to="/contact" className={`block py-2 text-gray-600 hover:text-primary-dark`}>Contact Us</Link>
        </div>
      )}
    </nav>
  </header>
  );
}



